<template>
  <ul class="a-list-element-actions a-list-element-actions-draggable position-left">
    <li>
      <a
        class="a-tooltip-primary a-tooltip-right text-color-third-action"
        :data-tooltip-text="$t('aListElementActionsSecondary.tooltipMove')"
        href="#"
        @click.prevent=""
      >
        <i class="far fa-arrows-alt"></i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AtomListElementActionsSecondary',

  props: {
    element: Object,
    position: String
  }
}
</script>
